import Vue from 'vue'
import Vuex from 'vuex'
import { alert } from './store/alert.module';
import { users } from './store/users.module';
import { heros } from './store/heros.module';
import { keyValues } from './store/keyValues.module';
import { members } from './store/members.module';
import { messages } from './store/messages.module';
import { prizes } from './store/prizes.module';
import { settings } from './store/settings.module';
import { staticInfos } from './store/staticInfos.module';
import { menuItems } from './store/menuItems.module';
import { products } from './store/products.module';

Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  }
}

export default new Vuex.Store({
  namespaced: true,
  state,
  mutations,
  modules: {alert,users,heros,keyValues,members,menuItems,messages,prizes,settings,staticInfos,products}
});